import Typography from '@material-ui/core/Typography/Typography';
import React from 'react';
import { RadarLegendLink } from './RadarLegendLink.esm.js';

const RadarLegendRing = ({
  ring,
  entries,
  classes,
  onEntryMouseEnter,
  onEntryMouseLeave
}) => {
  return /* @__PURE__ */ React.createElement("div", { "data-testid": "radar-ring", key: ring.id, className: classes.ring }, /* @__PURE__ */ React.createElement(
    "h3",
    {
      className: classes.ringHeading,
      style: { color: ring.color },
      "data-testid": "radar-legend-heading"
    },
    ring.name
  ), entries.length === 0 ? /* @__PURE__ */ React.createElement(Typography, { paragraph: true, className: classes.ringEmpty }, "(empty)") : /* @__PURE__ */ React.createElement("ol", { className: classes.ringList }, entries.map((entry) => /* @__PURE__ */ React.createElement(
    "li",
    {
      key: entry.id,
      value: (entry.index || 0) + 1,
      onMouseEnter: onEntryMouseEnter && (() => onEntryMouseEnter(entry)),
      onMouseLeave: onEntryMouseLeave && (() => onEntryMouseLeave(entry))
    },
    /* @__PURE__ */ React.createElement(
      RadarLegendLink,
      {
        classes,
        entryId: entry.id,
        url: entry.url,
        title: entry.title,
        description: entry.description,
        active: entry.active,
        links: entry.links ?? [],
        timeline: entry.timeline ?? []
      }
    )
  ))));
};

export { RadarLegendRing };
//# sourceMappingURL=RadarLegendRing.esm.js.map
